import type { ReactNode } from "react";
import type { CatalogMuscleSlug } from "@heraion/shared";

import type { UiTheme } from "../../theme";
import { CoveragePanel } from "./CoveragePanel";

// PE-27/PE-39 — the block that belongs to the WHOLE program, below both tabs.
// Coverage and the publication lifecycle both read the entire draft: neither
// belongs to one day or one week, so neither is gated by the surface switch.
//
// ⭐ THE ORDER IS THE FINDING, not a preference. Coverage is a READING;
// publishing is the only ACTION down here, and it shipped last — a coach who
// only wanted to publish had to scroll past something they were not reading
// (a11y audit, 30/08). The action goes first, the reading follows.
//
// ⛔ PE-46 — the target projection is NOT here any more, and putting a second
// reading back down here is the mistake this line exists to stop. It was placed
// beside the coverage panel because both "read the whole draft"; that analogy is
// not what §PE-27 says, and his smoke rejected it. The prescription's resume
// belongs INSIDE the card, as the logger's band.
export function PrescribeGlobalPanels({
  theme,
  hardSetsByMuscle,
  assigneesBand,
}: {
  // UiTheme: the phone editor (#336) mounts it too, without the Logger name.
  theme: UiTheme;
  hardSetsByMuscle: Partial<Record<CatalogMuscleSlug, number>>;
  // PE-48: who this program is assigned to. Ordered before the coverage
  // reading, matching the file's own action-before-reading rule above.
  assigneesBand?: ReactNode;
}) {
  return (
    <>
      {assigneesBand}
      <CoveragePanel theme={theme} hardSetsByMuscle={hardSetsByMuscle} />
    </>
  );
}
